<div *ngFor="let site of (sites$ | async)">
  <ng-container *ngIf="site">
    <!-- entête -->
    <p8-bdc-hero [site]="site" *ngIf="site"></p8-bdc-hero>
    <!-- -->
    <p8-bdc-categories [site]="site" *ngIf="site"></p8-bdc-categories>
    <p8-bdc-categories-list [site]="site" *ngIf="site"></p8-bdc-categories-list>
  </ng-container>
</div>
